import { Channel, CountWithComparison, CountWithComparisonAndChange, EmailAction } from '@/models';
import { QueryBaseOptions } from '@/types/cube';
import { FilterState } from '@/types/filter';
import { DeeplyReadonly, Filter, LogicalAndFilter } from '@cubejs-client/core';
import { Dayjs } from 'dayjs';

export const HCP_CUBE_NAME = 'hcp';
export const CUBE_NAME = 'interaction_individual_product_attendee';
export const CUBE_AGGREGATE_INTERACTION = 'interaction_aggregate';
export const CUBE_AGGREGATE_INTERACTION_EMPLOYEE = 'interaction_aggregate_employee';
export const CUBE_AGGREGATE_INTERACTION_PRODUCT = 'interaction_aggregate_product';
export const CUBE_AGGREGATE_INTERACTION_FIELD_FORCE = 'interaction_aggregate_field_force';
export const CUBE_WEBSITE_AGGREGATE_INTERACTION = 'interaction_aggregate_website_detail';
export const CUBE_INTERACTION_AGGREGATE_INSIGHTS = 'interaction_aggregate_insight';
export const CUBE_INTERACTION_INDIVIDUAL_WEBSITE_DETAIL = 'interaction_individual_website_detail';
export const INSIGHT_CUBE_NAME = 'insight';
export const LOCATION_CUBE_NAME = 'primary_location';
export const CUBE_CROSS_CHANNEL_INTERACTION = 'cross_channel_interaction';
export const CUBE_HCP_CONSENT_CHANNEL_TOPIC = 'hcp_consent_channel_topic_overview';
export const CUBE_HCP_CONSENT_CHANNEL_TOPIC_OVERVIEW = 'hcp_consent_channel_topic_overview';
export const CUBE_VOC_TO_INTERACTION_LINK = 'voc_to_interaction_link';
export const CUBE_VOC_TO_CUSTOMER_FEEDBACK = 'voc_customer_feedback';
export const CUBE_VOC_CUSTOMER_FEEDBACK = 'voc_customer_feedback';
export const CUBE_VOC_CUSTOMER_FEEDBACK_LATEST = 'voc_customer_feedback_latest';
export const CUBE_CONSENT = 'consent';
export const CUBE_INTERACTION_INDIVIDUAL_PRODUCT_ATTENDEE = 'interaction_individual_product_attendee';
export const CUBE_INTERACTION_INDIVIDUAL_ATTENDEE = 'interaction_individual_attendee';
export const CUBE_HCP_WO_INTERACTION = 'hcp_wo_interaction';
export const CUBE_HCP_TERRITORY = 'hcp_territory';
export const CUBE_CLINICAL_TRIALS = 'clinical_trials';
export const CUBE_HCP_SCIENTIFIC_ACTIVITY_SCORE = 'hcp_scientific_activity_score';
export const CUBE_VOC_CUSTOMER_FEEDBACK_CUSTOM_QUESTION = 'voc_customer_feedback_custom_question';
export const CUBE_AGGREGATE_INTERACTION_ATTENDEE = 'interaction_aggregate_attendee';
export const CUBE_CLASSIFICATION = 'classification';
export const CUBE_COMPETITOR_PARTNER_SCORE = 'competitor_partner_score';
export const CUBE_PARTNER_SCORE = 'partnerscore';
export const CUBE_INTERACTION_AGGREGATE_EMPLOYEE_INSIGHT = 'interaction_aggregate_employee_insight';
export const CUBE_INTERACTION_AGGREGATE_EMPLOYEE_LAG = 'interaction_aggregate_employee_submission_lag';
export const CUBE_INTERACTION_AGGREGATE_PRODUCT_MESSAGE = 'interaction_aggregate_product_message';
export const CUBE_INSIGHT_EMPLOYEE_FIELD_FORCE = 'insight_employee_field_force';
export const CUBE_INSIGHT_PRODUCT = 'insight_product';
export const CUBE_INSIGHT_TAG = 'insight_tag';
export const CUBE_VOC_CUSTOMER_FEEDBACK_INTERACTION_INDIVIDUAL = 'voc_customer_feedback_interaction_individual';

export type EmailFunnelResult = {
  [key in EmailAction]: {
    count: CountWithComparisonAndChange;
    rate: CountWithComparisonAndChange;
  };
};

export interface InteractionCount {
  month: Dayjs;
  type: string;
  count: number;
}

export interface InteractionCoverage {
  month: Dayjs;
  rate1: number;
  rate2?: number;
  type: string;
}

export type HCPsContactedResult = {
  noHcpsContacted: CountWithComparison;
  noHcpsContactedUnique: CountWithComparison;
};

export type EmailInteractionsDetails = {
  name: string;
  channel: string;
  sent: number;
  bounced: number;
  clicked: number;
  opened: number;
};

export interface EventData {
  noOfEvents: { current: number; previous: number };
  noOfInvitations: { current: number; previous: number };
  noOfUniqueParticipants: { current: number; previous: number };
}

export interface ChannelConfig {
  measures: string[];
  dimensions?: string[];
  timeDimension: string;
}

export interface ChannelConfigMap extends Partial<Record<Channel, ChannelConfig>> {
  default: ChannelConfig;
}

export type CubeRecord = string | number | boolean;

export interface CubeRowData {
  [key: string]: CubeRecord;
}

export interface CreateCubeQueryParams {
  channel: Channel;
  from: Dayjs;
  to: Dayjs;
  additionalChannelFilters: LogicalAndFilter;
  channelFilter: DeeplyReadonly<Filter>;
  globalFilter: LogicalAndFilter;
  additionalFilters: LogicalAndFilter;
}

export interface UseGetInteractionGroupedByMonthParams {
  channel: Channel;
  from: Dayjs;
  to: Dayjs;
  secondaryFilter?: Partial<FilterState>;
  options?: QueryBaseOptions;
  additionalFilters?: LogicalAndFilter;
  isSecondarySegment?: boolean;
}
